import { gql } from "@apollo/client";
import Grid from "atoms/Grid";
import useData from "helpers/useData";
import Section from "molecules/Section";
import React from "react";

import EventCard, { EventCardFragment } from "./EventCard";

export const GameOverviewHighlightsFragment = gql`
  fragment GameOverviewHighlightsFragment on Game {
    id
  }
`;

export default function GameOverviewHighlights({ gamePlayer }) {
  const [data] = useData(
    gql`
      query GameOverviewHighlights($gamePlayerId: ID!) {
        gamePlayer(id: $gamePlayerId) {
          id
          events {
            id
            ...EventCardFragment
          }
        }
      }
      ${EventCardFragment}
    `,
    {
      gamePlayerId: gamePlayer?.id,
    },
    {
      skip: !gamePlayer,
    },
  );

  if (!data?.gamePlayer?.events?.length) {
    return null;
  }

  return (
    <Section title={`HIGHLIGHTS`}>
      <Grid gridItemWidth="160px">
        {data?.gamePlayer?.events?.map((event) => (
          <EventCard key={event.id} event={event} />
        ))}
      </Grid>
    </Section>
  );
}
